import { c as e, d as t, o as n, t as r, u as i } from "./_plugin-vue_export-helper-B-med9Jm.js";
import { t as a } from "./author-dropdown-selector-DY4fxs1F.js";
import { CMSNotification as o, SEARCH_DEBOUNCE as s, VuetifyValidationRules as c, getI18n as l, useCardDragSort as u, useNotificationStore as d } from "@editor/ui-utils";
import { QChip as f, QIcon as p, QSelect as m } from "quasar";
import { computed as h, createBlock as g, createCommentVNode as _, createElementBlock as v, createTextVNode as y, createVNode as b, defineComponent as x, mergeProps as S, onMounted as C, openBlock as w, ref as T, toDisplayString as E, unref as D, useAttrs as O, withCtx as k } from "vue";
import { useI18n as A } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var j = {
	en: {
		authorsApi: {
			createAlreadyExists: "The author cannot be created because another author with this name already exists.",
			updateAlreadyExists: "The author cannot be updated because another author with this name already exists.",
			created: "Author created",
			updated: "Author updated",
			notFound: "Author not found",
			requiredFields: "The author cannot be saved because mandatory information is missing.",
			invalidEmail: "The author cannot be saved because the email address is invalid."
		},
		authorsList: {
			title: "Author",
			newButton: "New author",
			name: "Search for name",
			status: "Status",
			dpAny: "All",
			statusActive: "Active",
			statusInactive: "Inactive",
			loading: "Loading authors",
			headerStatus: "Status",
			headerName: "Display name",
			headerCreatedAt: "Creation date",
			messageActive: "Author active",
			messageInactive: "Author blocked",
			dpEdit: "Edit",
			dpView: "View",
			dpActive: "Block",
			dpInactive: "Unblock",
			noEditTooltip: "This author is originally from the {source} editor.",
			statusBrands: "Brand"
		},
		authorsSelector: { changeDateLabel: "Last modified date" },
		authors: {
			firstname: "First name",
			lastname: "Last name",
			isEnabled: "Active",
			legacyAuthors: "Legacy Author",
			displayName: "Display name",
			jobTitle: "Job title",
			biography: "Biography",
			xing: "Xing URL",
			linkedin: "LinkedIn URL",
			twitter: "X-URL (ex Twitter)",
			facebook: "Facebook URL",
			instagram: "Instagram URL",
			tiktok: "Tiktok URL",
			email: "Email",
			settings: "Settings",
			showArticles: "Show articles",
			showImageOnTeasers: "Show author image on channel teasers",
			showImageOnTeasersTooltip: "When enabled, this author's photo appear on Home and Channel teaser cards for articles they are assigned to. Up to two author photos are shown per teaser; additional authors appear as +N.",
			vgWort: "VG-Wort author number",
			profileUrl: "Author profile URL",
			path: "Path",
			pathPlaceholder: "Will be filled automatically",
			toAuthorProfile: "To author profile",
			toAuthorPage: "To author",
			messageMandatoryInfo: "The author cannot be saved because mandatory information is missing.",
			messageUpdated: "Author updated",
			messageCopy: "Path copied to clipboard",
			messageCreated: "Author created",
			messageDeleted: "Author deleted",
			messageDeleteAuthor: "The author will be hidden from selection lists. Existing article references will remain intact.",
			messageDeleteAuthorTitle: "Delete author?",
			messageDeleteAuthorFailed: "Failed to delete author",
			softDelete: "Delete author",
			createdAssigned: "Author created and linked to user",
			selectAuthors: "Author",
			errorFailedLoadAuthor: "Failed to load author",
			deletedAuthor: "Deleted author",
			noResults: "No authors found",
			loading: "Loading authors…",
			handledInLegacySystem: "This author is being handled in {source}. It cannot be edited in Vibe.",
			hasBeenMerged: "This author has been merged to {link}. Please edit author details there.",
			jobTitlePrefix: "Job title prefix",
			router: {
				createAuthor: "Create author",
				editAuthor: "Edit author"
			}
		},
		authorMerge: {
			preMergeBtn: "Pre-merge info",
			startMergeBtn: "Start author merge",
			startReMergeBtn: "Re-merge authors",
			reMergeTooltip: "All legacy authors of the selected brand that have already been merged into Vibe authors will be merged again into the same Vibe authors.",
			allowedMergeToggle: "Allow merged authors",
			allowedMergeTooltip: "Legacy authors that have already been merged can be merged again if they are referenced in Vibe authors.",
			issuesTitle: "Issue report",
			mergeDialogTitle: "Are you sure you want to merge legacy authors?",
			mergeDialogMessage: "Merging a legacy author into a Vibe author is irreversible. The Vibe author will remain and will be referenced in articles instead of the selected legacy author. Are you sure you want to proceed?",
			singleAuthorMergeLabel: "Merge authors",
			singleAuthorMergeTooltip: "Merges legacy author into current Vibe author, inheriting some fields and taking ownership of legacy articles",
			singleAuthorMergeSuccessMsg: "Author merged successfully",
			singleAuthorMergeIssueMsg: "Merge issue encountered: {message}",
			singleAuthorMergeMandatoryInfoMissingMsg: "Mandatory author information is missing to perform the merge"
		}
	},
	de: {
		authorsApi: {
			createAlreadyExists: "Der Autor konnte nicht erstellt werden, weil bereits ein Autor mit diesem Namen existiert.",
			updateAlreadyExists: "Der Autor konnte nicht gespeichert werden, weil bereits ein Autor mit diesem Namen existiert.",
			created: "Autor erstellt",
			updated: "Autor aktualisiert",
			notFound: "Autor nicht gefunden",
			requiredFields: "Der Autor kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			invalidEmail: "Der Autor kann nicht gespeichert werden, weil die E-Mail-Adresse ungültig ist."
		},
		authorsList: {
			title: "Autor",
			newButton: "Neuer Autor",
			name: "Suchen nach Name",
			status: "Status",
			dpAny: "Alle",
			statusActive: "Aktiv",
			statusInactive: "Inaktiv",
			loading: "Autoren werden geladen",
			headerStatus: "Status",
			headerName: "Anzeigename",
			headerCreatedAt: "Erstellungsdatum",
			messageActive: "Autor aktiv",
			messageInactive: "Autor gesperrt",
			dpEdit: "Bearbeiten",
			dpActive: "Sperren",
			dpView: "Anzeigen",
			dpInactive: "Freischalten",
			noEditTooltip: "Dieser Autor stammt ursprünglich vom {source}-Editor.",
			statusBrands: "Marke"
		},
		authorsSelector: { changeDateLabel: "Änderungsdatum (last modified)" },
		authors: {
			firstname: "Vorname",
			lastname: "Nachname",
			isEnabled: "Aktiv",
			legacyAuthors: "Legacy-Autor",
			displayName: "Anzeigename",
			jobTitle: "Jobtitel",
			biography: "Biografie",
			xing: "Xing-URL",
			linkedin: "LinkedIn-URL",
			twitter: "X-URL (Ex-Twitter)",
			facebook: "Facebook-URL",
			instagram: "Instagram-URL",
			tiktok: "Tiktok-URL",
			email: "E-Mail-Adresse",
			settings: "Einstellungen",
			showArticles: "Artikel anzeigen",
			showImageOnTeasers: "Autorenbild auf Channel-Teasern anzeigen",
			showImageOnTeasersTooltip: "Wenn aktiviert, erscheint das Foto dieses Autors auf Home- und Channel-Teaserkarten für Artikel, denen er zugeordnet ist. Pro Teaser werden bis zu zwei Autorenfotos angezeigt; weitere Autoren erscheinen als +N.",
			vgWort: "VG-Wort-Nummer",
			profileUrl: "Autorenprofil-URL",
			path: "Pfad",
			pathPlaceholder: "Wird automatisch ausgefüllt",
			toAuthorProfile: "Zum Autorenprofil",
			toAuthorPage: "Zum Autor",
			messageMandatoryInfo: "Der Autor kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			messageUpdated: "Autor aktualisiert",
			messageCopy: "Pfad in die Zwischenablage kopiert",
			messageCreated: "Autor erstellt",
			messageDeleted: "Autor gelöscht",
			messageDeleteAuthor: "Der Autor wird in Auswahllisten ausgeblendet. Bestehende Artikelverweise bleiben erhalten.",
			messageDeleteAuthorTitle: "Autor löschen?",
			messageDeleteAuthorFailed: "Autor konnte nicht gelöscht werden",
			softDelete: "Autor löschen",
			createdAssigned: "Autor erstellt und mit Nutzer verknüpft",
			selectAuthors: "Autor",
			errorFailedLoadAuthor: "Fehler beim Laden des Autors",
			deletedAuthor: "Gelöschter Autor",
			noResults: "Keine Autor:innen gefunden",
			loading: "Autor:innen werden geladen…",
			handledInLegacySystem: "Dieser Autor wird in {source} verwaltet. Die Bearbeitung in  Vibe ist nicht möglich.",
			hasBeenMerged: "Dieser Autor wurde mit {link} zusammengeführt. Bitte die Autorendaten dort bearbeiten.",
			jobTitlePrefix: "Job title prefix",
			router: {
				createAuthor: "Autor erstellen",
				editAuthor: "Autor bearbeiten"
			}
		},
		authorMerge: {
			preMergeBtn: "Vorab-Informationen",
			startMergeBtn: "Autoren-Zusammenführung starten",
			startReMergeBtn: "Autoren erneut zusammenführen",
			reMergeTooltip: "Alle Legacy-Autoren der angegebenen Marke, die bereits mit einem Vibe-Autor zusammengeführt wurden, werden erneut mit demselben Vibe-Autor zusammengeführt.",
			allowedMergeToggle: "Zusammengeführte Autoren zulassen",
			allowedMergeTooltip: "Bereits zusammengeführte Legacy-Autoren dürfen erneut zusammengeführt werden, wenn sie in Vibe-Autoren referenziert werden.",
			issuesTitle: "Fehlerbericht",
			mergeDialogTitle: "Willst du die Legacy-Autoren wirklich zusammenführen?",
			mergeDialogMessage: "Das Zusammenführen eines Legacy-Autors mit einem Vibe-Autor ist irreversibel. Der Vibe-Autor bleibt erhalten und wird künftig in Artikeln anstelle des ausgewählten Legacy-Autors referenziert. Willst du wirklich fortfahren?",
			singleAuthorMergeLabel: "Autoren zusammenführen",
			singleAuthorMergeTooltip: "Führt den Legacy-Autor mit dem aktuellen Vibe-Autor zusammen und übernimmt bestimmte Felder und die Ownership für ältere Artikel",
			singleAuthorMergeSuccessMsg: "Autor zusammengeführt: {message}",
			singleAuthorMergeIssueMsg: "Merge-Problem aufgetreten: {message}",
			singleAuthorMergeMandatoryInfoMissingMsg: "Beim Autor fehlen Pflichtinformationen, um den Merge durchzuführen"
		}
	}
}, M = [{
	path: "/authors",
	children: [
		{
			path: "",
			name: "authors_list",
			component: () => import("./author-list.view-CSP8o3CY.js"),
			meta: { requiredRight: "authors:navigate" }
		},
		{
			path: "new",
			name: "author_new",
			component: () => import("./author-edit.view-BC_B7Obb.js"),
			props: () => ({
				title: l().t("authors.router.createAuthor"),
				backRoute: "/authors"
			}),
			meta: { requiredRight: ["authors:navigate"] }
		},
		{
			path: ":id",
			name: "author_detail",
			component: () => import("./author-edit.view-BC_B7Obb.js"),
			props: (e) => ({
				title: l().t("authors.router.editAuthor"),
				id: e.params.id,
				backRoute: "/authors"
			}),
			meta: { requiredRight: ["authors:navigate"] }
		},
		{
			path: "/author-merge",
			name: "author_merge",
			component: () => import("./author-merge.view-Dvg_Har5.js"),
			meta: { requiredRight: "authors:merge" }
		}
	]
}], N = {
	key: 0,
	class: "drop-indicator"
}, P = {
	key: 1,
	class: "drop-indicator"
}, F = /* @__PURE__ */ r(/* @__PURE__ */ x({
	__name: "author-tag-selector",
	props: {
		modelValue: { default: void 0 },
		sortable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(r, { emit: a }) {
		let { t: l } = A(), { required: x } = c, j = O(), M = d(), F = a, I = T(), L = r, R = T([]), z = h(() => R.value.map((e) => ({
			label: `${e.firstname} ${e.lastname}`,
			value: e._id
		}))), B = async (e) => {
			let t = R.value.find((t) => t._id === e);
			if (!t) try {
				t = await i(e), R.value.push(t);
			} catch {
				return M.showNotification(new o(l("authors.errorFailedLoadAuthor", { id: e }))), "";
			}
			return `${t.firstname} ${t.lastname}`.trim();
		}, V = async () => L.modelValue?.length ? t(L.modelValue, R.value) : [], H = (t, r) => {
			r(async () => {
				let { list: r } = await n(t, {
					searchfields: ["firstname", "lastname"],
					isEnabled: !0,
					source: "vibe"
				});
				R.value = e(r, await V());
			});
		}, U = () => {
			I.value?.updateInputValue("");
		}, W = (e, t) => {
			t(), U();
		}, G = h({
			get() {
				return L.modelValue ?? [];
			},
			set(e = []) {
				F("update:modelValue", e.map((e) => typeof e == "object" ? e.value : e) ?? []);
			}
		}), { dragOverId: K, insertBefore: q, onDragStart: J, onDragOver: Y, onDragLeave: X, onDrop: Z, onDragEnd: Q } = u(G), $ = (e) => typeof e == "object" ? e.value : e, ee = h(() => !!j.disable), te = (e) => ({
			draggable: L.sortable && !ee.value,
			onDragstart: () => J(e),
			onDragover: (t) => Y(t, e),
			onDragleave: X,
			onDrop: () => Z(e),
			onDragend: Q
		});
		return C(async () => {
			let { list: t } = await n();
			R.value = e(t, await V());
		}), (e, t) => (w(), g(D(m), S({
			ref_key: "authorTagSelector",
			ref: I,
			modelValue: G.value,
			"onUpdate:modelValue": t[0] ||= (e) => G.value = e,
			outlined: "",
			dense: "",
			label: D(l)("authors.selectAuthors"),
			options: z.value,
			rules: [D(x)],
			"new-value-mode": "add-unique",
			"data-qa-author-tags-selector": "",
			"use-input": "",
			"use-chips": ""
		}, e.$attrs, {
			"map-options": "",
			multiple: "",
			"input-debounce": D(s),
			"dropdown-icon": "expand_more",
			onAdd: U,
			onFilter: H,
			onNewValue: W
		}), {
			"selected-item": k((e) => [
				r.sortable && D(K) === $(e.opt) && D(q) ? (w(), v("div", N)) : _("", !0),
				b(D(f), S({
					"data-qa-author-tag": "",
					removable: "",
					dense: "",
					color: "cyan-1",
					"text-color": "dark",
					tabindex: e.tabindex
				}, r.sortable ? te($(e.opt)) : {}, { onRemove: (t) => e.removeAtIndex(e.index) }), {
					default: k(() => [r.sortable ? (w(), g(D(p), {
						key: 0,
						name: "drag_indicator",
						class: "drag-handle cursor-move q-mr-xs"
					})) : _("", !0), y(" " + E(e.opt.label || B(e.opt)), 1)]),
					_: 2
				}, 1040, ["tabindex", "onRemove"]),
				r.sortable && D(K) === $(e.opt) && !D(q) ? (w(), v("div", P)) : _("", !0)
			]),
			_: 1
		}, 16, [
			"modelValue",
			"label",
			"options",
			"rules",
			"input-debounce"
		]));
	}
}), [["__scopeId", "data-v-08d04aff"]]), I = {
	messages: j,
	routes: M
};
//#endregion
export { a as AuthorDropdownSelector, F as AuthorTagSelector, I as authorModule, n as getAuthors };

//# sourceMappingURL=index.es.js.map